import React, { useState } from "react";
import { format, parse } from "date-fns";
import { useFormikContext } from "formik";
import DatePickerField from "components/lib/Shared/DatePickerField";
import { useSelector } from "react-redux";

const ManageAppointmentDate = ({ field, form, disabled, designation }) => {
  const { setFieldValue } = useFormikContext();
  const [startDate, setStartDate] = useState("");
  const { company } = useSelector((state) => state.companySlice);

  const minAppointmentDate = new Date(company?.registrationDate);

  const handleDateValue = (date) => {
    setFieldValue("appointmentDate", format(date, "yyyy/MM/dd"));
    return setStartDate(date);
  };

  const selectedDOB = field.value ? new Date(field.value) : startDate;

  return (
    <div className="col-span-6 sm:col-span-3">
      <DatePickerField
        label={`Date of Becoming as ${designation}`}
        form={form}
        onChange={handleDateValue}
        selected={selectedDOB}
        minDate={minAppointmentDate}
        maxDate={new Date()}
        name="appointmentDate"
        placeholderText="Enter dates of becoming"
        errorPath="appointmentDate"
        disabled={false}
        showRequiredAsterisk={true}
      />
    </div>
  );
};

export default ManageAppointmentDate;
